module.exports = __webpack_public_path__ + "static/media/software_version.b0ad40ba.svg";